export enum LayoutType {
  NavigationLayout = "NavigationLayout",
  FormLayout = "FormLayout",
  NoneLayout = "NoneLayout"
}
